import TypographySkeleton from './TypographySkeleton';

export default TypographySkeleton;
